import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Badge extends Model {
  constructor() {
    super(...arguments);
    // Attributes
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "icon", Model.attribute('icon'));
    _defineProperty(this, "iconColor", Model.attribute('iconColor'));
    _defineProperty(this, "backgroundColor", Model.attribute('backgroundColor'));
    _defineProperty(this, "triggerConfig", Model.attribute('triggerConfig'));
    _defineProperty(this, "actions", Model.attribute('actions'));
    _defineProperty(this, "isActive", Model.attribute('isActive'));
    _defineProperty(this, "isVisible", Model.attribute('isVisible'));
    _defineProperty(this, "earnedCount", Model.attribute('earnedCount'));
    _defineProperty(this, "order", Model.attribute('order'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "rarity", Model.attribute('rarity'));
    _defineProperty(this, "isEarned", Model.attribute('isEarned'));
    _defineProperty(this, "canEdit", Model.attribute('canEdit'));
    _defineProperty(this, "categoryId", Model.attribute('categoryId'));
    // Relationships
    _defineProperty(this, "category", Model.hasOne('category'));
  }
}
flarum.reg.add('fof-badges', 'common/models/Badge', Badge);